import { render, staticRenderFns } from "./VectorLegend.vue?vue&type=template&id=772bed7a&scoped=true"
import script from "./VectorLegend.vue?vue&type=script&lang=ts"
export * from "./VectorLegend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772bed7a",
  null
  
)

export default component.exports